















import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import '../assets/css/SuccessBox.scss';
import '../assets/css/ConfirmationBox.scss';
import MessageBox from '../components/MessageBox.vue';
@Component({
    components: {
        MessageBox,
    },
})
export default class AcceptRequest extends Vue {
    private showSuccessBox = false;
    private id: string = '';
    public mounted() {
        this.acceptRequest(this.$route.params.id);
    }

    private async acceptRequest(requestId: string) {
        this.id = requestId;
        const requestDetailsResponse = await ObjectFactory.getRequestService().
            getRequestDetails(requestId, this.$store.state.serverUrl);
        if (requestDetailsResponse.success && requestDetailsResponse.data) {
            if (requestDetailsResponse.data.transportRequest &&
                requestDetailsResponse.data.status === 'Pending') {
                this.$router.push({
                    path: `${MedTransGoConstants.URL_REQUESTS}/${requestId}`,
                    query: { requestType: 'transportRequest', accept: 'show' },
                });
                return;
            }
            const response = await ObjectFactory.getRequestService().
                acceptRequest(requestId, this.$store.state.serverUrl);
            if (response.success) {
                this.showSuccessBox = true;
                return;
            }
        }
        const messageBox: any = this.$refs.messageBox;
        messageBox.showModal();
    }

    private gotoRequests(id?: string) {
        if (id) {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}/${id}` });
        } else {
            this.$router.push({ path: `${MedTransGoConstants.URL_REQUESTS}` });
        }
    }
}
